<button class="shortcut-menu__button" (click)="navigateToCert()">
  <svg-icon src="assets/images/icons/cert.svg"></svg-icon>
  <span>{{ "ShortcutMenu.ToCert" | translate }}</span>
</button>
